import React, { Component } from 'react';

class OverrideCarousel extends Component {
  getIndexes(count, inc) {
    const arr = [];
    for (let i = 0; i < count; i += inc) {
      arr.push(i);
    }
    return arr;
  }

  getListStyles() {
    return {
      position: 'relative',
      margin: 0,
      padding: 0,
      zIndex: 99,
      bottom: 0
    };
  }

  getListItemStyles() {
    return {
      listStyleType: 'none',
      display: 'inline-block'
    };
  }

  getButtonStyles(active) {
    return {
      border: 0,
      background: 'transparent',
      color: active ? '#55bdfc' : '#333',
      cursor: 'pointer',
      padding: 10,
      outline: 0,
      fontSize: 24,
      opacity: active ? 1 : 0.5
    };
  }

  render() {
    const self = this;
    const indexes = this.getIndexes(self.props.slideCount, self.props.slidesToScroll);
    return (
      <ul style={self.getListStyles()}>
        {
          indexes.map(index =>
            <li style={self.getListItemStyles()} key={index}>
              <button
                style={self.getButtonStyles(self.props.currentSlide === index)}
                key={`button_, ${index}!`}
              >
                &bull;
              </button>
            </li>
          )
        }
      </ul>
    );
  }
}

export default OverrideCarousel;



// WEBPACK FOOTER //
// ./src/components/OverrideCarousel/Decorators.js